// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.WGlN9xo1Qisxv1vjDDjd {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ixGdHL36v080ULGpaNvd {
  padding-left: 40px;
}

.aXkDc6_ZP1uwXzkZhUwi::before {
  padding-left: 10px;
  content: "•";
  font-weight: bold;
  margin-right: 0.5em;
}

.VeZSOHdvppchGbL7RTxQ {
  margin-top: 5px;
  margin-bottom: 5px;
}

.LL4mboGMqMjeN5vv6ey4 {
  padding: 10px 20px;
  border-inline: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  border-radius: 2px;
}

.XX3DgVp68BouNa_1hZNw {
  display: inline;
  vertical-align: bottom;
}

.X1APy7ESypfZ1GuQxlxT {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: calc(100% - 200px);
  vertical-align: middle;
}

.UpVr3r_VZJFVWS9mcfvR {
  overflow: visible;
  text-align: justify;
}
.UpVr3r_VZJFVWS9mcfvR .SqUQ4v6EtOHxKCSO7wBv {
  padding-left: 20px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}
.UpVr3r_VZJFVWS9mcfvR .SqUQ4v6EtOHxKCSO7wBv::before {
  content: "";
  display: inline-block;
  width: 0;
  margin-left: -20px;
}

.kRK4xPg6kiXfQRcDGSuX {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.jnkJoW1rlO7EtD04Fnbb {
  flex: 1 1 auto;
  min-width: 0;
}

.UcSgRi8KEepItJaHIWUu:not(:last-child)::after {
  content: ", ";
}

.rORdNiJJisMHHBDMjXiX {
  display: flex;
  align-self: flex-start;
  flex-shrink: 0;
  max-width: 100%;
  width: 200px;
}

.L9xQwxkImmMRBWu73d4w {
  width: 100%;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
}

@media (max-width: 767px) {
  .kRK4xPg6kiXfQRcDGSuX {
    flex-direction: column;
  }

  .rORdNiJJisMHHBDMjXiX {
    width: min(200px, 100%);
  }
}
.sJft8LrxMqmquQVdZCRy {
  position: relative;
  width: 300px;
}

.iAOfS_czGyxZ_TMtM9l0 {
  border-radius: 3px !important;
  min-height: 38px !important;
  font-size: 1rem !important;
  padding-right: 30px !important;
}

.i7OKH_9pWhhGhyVyywHI {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.CSajIpqM0TvdNTQG7OOM {
  display: flex !important;
  font-size: 14px !important;
  text-decoration: underline !important;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/ioc/ioc.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;EACA,gCAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,mCAAA;EACA,2BAAA;AACJ;AACI;EACE,WAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AACN;;AAIA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AADF;;AAIA;EACE,cAAA;EACA,YAAA;AADF;;AAKE;EACE,aAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE;IACE,sBAAA;EAHF;;EAMA;IACE,uBAAA;EAHF;AACF;AAMA;EACE,kBAAA;EACA,YAAA;AAJF;;AAOA;EACE,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAJF;;AAOA;EACE,wBAAA;EACA,0BAAA;EACA,qCAAA;AAJF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.ioc_key_value_entry {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ioc_campaign_header {\n  padding-left: 40px;\n}\n\n.campaign_iocs_bullet::before {\n  padding-left: 10px;\n  content: '•';\n  font-weight: bold;\n  margin-right: 0.5em;\n}\n\n.campaign_ioc_title {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.campaign_ioc_body {\n  padding: 10px 20px;\n  border-inline: 1px solid $border-color-default;\n  border-bottom: 1px solid $border-color-default;\n  border-radius: 2px;\n}\n\n.line_clamp_container {\n  display: inline;\n  vertical-align: bottom;\n}\n\n.line_clamp {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: inline-block;\n  max-width: calc(100% - 200px);\n  vertical-align: middle;\n}\n\n.expanded {\n  overflow: visible;\n  text-align: justify;\n\n  .indented_inline {\n    padding-left: 20px;\n    -webkit-box-decoration-break: clone;\n    box-decoration-break: clone;\n\n    &::before {\n      content: \"\";\n      display: inline-block;\n      width: 0;\n      margin-left: -20px;\n    }\n  }\n}\n\n.actor_insights_layout {\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n}\n\n.actor_insights_details {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.actor_name_item {\n  &:not(:last-child)::after {\n    content: \", \";\n  }\n}\n\n.actor_image_container {\n  display: flex;\n  align-self: flex-start;\n  flex-shrink: 0;\n  max-width: 100%;\n  width: 200px;\n}\n\n.actor_image {\n  width: 100%;\n  height: auto;\n  border-radius: 16px;\n  object-fit: cover;\n}\n\n@media (max-width: 767px) {\n  .actor_insights_layout {\n    flex-direction: column;\n  }\n\n  .actor_image_container {\n    width: min(200px, 100%);\n  }\n}\n\n.ioc_filter_container {\n  position: relative;\n  width: 300px;\n}\n\n.ioc_search_filter {\n  border-radius: 3px !important;\n  min-height: 38px !important;\n  font-size: 1rem !important;\n  padding-right: 30px !important;\n}\n\n.ioc_search_icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.ioc_clear_button {\n  display: flex !important;\n  font-size: 14px !important;\n  text-decoration: underline !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ioc_key_value_entry": `WGlN9xo1Qisxv1vjDDjd`,
	"ioc_campaign_header": `ixGdHL36v080ULGpaNvd`,
	"campaign_iocs_bullet": `aXkDc6_ZP1uwXzkZhUwi`,
	"campaign_ioc_title": `VeZSOHdvppchGbL7RTxQ`,
	"campaign_ioc_body": `LL4mboGMqMjeN5vv6ey4`,
	"line_clamp_container": `XX3DgVp68BouNa_1hZNw`,
	"line_clamp": `X1APy7ESypfZ1GuQxlxT`,
	"expanded": `UpVr3r_VZJFVWS9mcfvR`,
	"indented_inline": `SqUQ4v6EtOHxKCSO7wBv`,
	"actor_insights_layout": `kRK4xPg6kiXfQRcDGSuX`,
	"actor_insights_details": `jnkJoW1rlO7EtD04Fnbb`,
	"actor_name_item": `UcSgRi8KEepItJaHIWUu`,
	"actor_image_container": `rORdNiJJisMHHBDMjXiX`,
	"actor_image": `L9xQwxkImmMRBWu73d4w`,
	"ioc_filter_container": `sJft8LrxMqmquQVdZCRy`,
	"ioc_search_filter": `iAOfS_czGyxZ_TMtM9l0`,
	"ioc_search_icon": `i7OKH_9pWhhGhyVyywHI`,
	"ioc_clear_button": `CSajIpqM0TvdNTQG7OOM`
};
export default ___CSS_LOADER_EXPORT___;
